import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=18fb1c38&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=js"
export * from "./PaginationControls.vue?vue&type=script&lang=js"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=18fb1c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb1c38",
  null
  
)

export default component.exports